import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { formatDuration } from "./helpers";
import { getTrackedMinutes, getTaxRate } from "./AdminCostCard";

export const SummaryCard = ({ order, totals, onStatusChange, companySettings }) => {
  const materialNet = totals.totalCost || 0;
  const stundenlohn = parseFloat(companySettings?.stundenlohn || 0);
  const taxRate = getTaxRate(companySettings);
  const trackedMinutes = getTrackedMinutes(order, totals);
  const laborNet = (trackedMinutes / 60) * stundenlohn;
  const netto = materialNet + laborNet;
  const steuer = (netto * taxRate) / 100;
  const brutto = netto + steuer;
  const hasLabor = laborNet > 0;

  return (
    <Card data-testid="detail-summary-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Zusammenfassung</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="text-center p-3 bg-blue-50 rounded-lg">
            <p className="text-2xl font-bold text-blue-600">{totals.totalTasks}</p>
            <p className="text-xs text-muted-foreground">Aufgaben</p>
          </div>
          <div className="text-center p-3 bg-green-50 rounded-lg">
            <p className="text-2xl font-bold text-green-600">{totals.completedTasks}</p>
            <p className="text-xs text-muted-foreground">Erledigt</p>
          </div>
          <div className="text-center p-3 bg-orange-50 rounded-lg">
            <p className="text-2xl font-bold text-orange-600">{formatDuration(trackedMinutes)}</p>
            <p className="text-xs text-muted-foreground">Zeit erfasst</p>
          </div>
          <div className="text-center p-3 bg-purple-50 rounded-lg">
            <p className="text-2xl font-bold text-purple-600">{netto.toFixed(2)} €</p>
            <p className="text-xs text-muted-foreground">Gesamt (netto)</p>
          </div>
        </div>

        {netto > 0 && (
          <div className="bg-muted/40 rounded-lg p-3 text-sm space-y-1">
            <div className="flex justify-between text-muted-foreground">
              <span>Material (netto)</span>
              <span className="font-medium text-foreground" data-testid="summary-material-net">{materialNet.toFixed(2)} €</span>
            </div>
            {hasLabor && (
              <div className="flex justify-between text-muted-foreground">
                <span>Arbeit ({formatDuration(trackedMinutes)} × {stundenlohn.toFixed(2)} €/h)</span>
                <span className="font-medium text-foreground" data-testid="summary-labor-net">{laborNet.toFixed(2)} €</span>
              </div>
            )}
            <Separator className="my-2" />
            <div className="flex justify-between text-muted-foreground">
              <span>VK netto</span>
              <span className="font-medium text-foreground">{netto.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between text-muted-foreground">
              <span>MwSt ({taxRate}%)</span>
              <span className="font-medium text-foreground">{steuer.toFixed(2)} €</span>
            </div>
            <Separator className="my-2" />
            <div className="flex justify-between items-center">
              <span className="font-medium">Gesamt (brutto)</span>
              <span className="text-lg font-bold text-primary" data-testid="summary-brutto-total">{brutto.toFixed(2)} €</span>
            </div>
          </div>
        )}

        <Separator />
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <Label className="shrink-0">Status ändern:</Label>
          <Select value={order.status} onValueChange={onStatusChange}>
            <SelectTrigger className="w-full sm:w-48" data-testid="detail-status-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="offen">Offen</SelectItem>
              <SelectItem value="in_bearbeitung">In Bearbeitung</SelectItem>
              <SelectItem value="erledigt">Erledigt</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
};
